import appconfig from '@/utils/appConfig';

interface MaxWidthContainerProps {
    children: React.ReactNode;
    className?: string;
}

const MaxWidthContainer = ({ children, className }: MaxWidthContainerProps) => {
    const containerStyles = `${appconfig.maxSiteWidth} ${className || ''}`;

    return <div className={containerStyles}>{children}</div>;
};

export default MaxWidthContainer;
